export default {
    actionList: {
        cancel: 'Cancel',

        statuses: {
            key2: {
                label: 'Confirmed',
                confirm: 'Are you sure you want to confirm the order?',
            },
            key3: {
                label: 'Not confirmed',
                confirm: 'Are you sure you want to transfer the order to unconfirmed?',
            },
            key7: {
                label: 'Generate',
                confirm: 'Are you sure you want to transfer the orders to the generated ones?',
            },
            key11: {
                label: 'Issue ',
                confirm: 'Are you sure you want to issue an order?',
            },
            key20: {
                label: 'Returned to the warehouse',
                confirm: 'Are you sure you want to return the order to the warehouse?',
            },
            key27: {
                label: 'Generate',
                confirm: 'Are you sure you want to transfer the orders to the generated ones?',
            },
        },
    },

    allFields: {
        id: 'Order number',
        status: 'Processing status',
        orderDateCC: 'Confirmation date',
        deliveryStatus: 'Delivery status',
        payType: 'Payment type',
        payStatus: 'Payment status',
        dateCreate: 'Date of creation',
        timeWaiting: 'Order waiting period (in days)',
        sourceType: 'Order source',
        userAuthorization: 'User status',
        deliveryServiceMethod: 'Delivery method',
        deliveryServiceType: 'Type of delivery',
        acceptanceActNumber: 'APP Number',
        dateShipment: 'Date of transfer to KS',
        pfm: 'PFM Store Code',
        dateDone: 'Date of receipt by the buyer',
        orderProducts: 'Products',
        deliverySumClient: 'Shipping cost',
        city: 'The locality of the store',
        address: 'Store address',
        manager: 'Manager',
        dateUpdate: 'Date of change',
        isTest: 'Test order',
        actions: 'Action',
        partnerOrderId: 'Partner order number',
    },

    index: {
        textFormsPre: 'Found | Found | Found',
        textFormsPast: "order | order's | orders",
        deliveryServiceType: 'Pickup',

        table: {
            th1: 'PA of the product',
            th2: 'Quantity, pieces',
            th3: 'Cost, units',
            th4: 'The cost of the goods, total',
        },

        subscription: 'LP Subscription',
        fieldsExcel: 'List of orders',
        paidForPickup: 'Paid for pickup',
        pfmNotFound: 'PFM not found!',
        pickupWithCashPay: 'Pickup with payment in store',
    },
};